import React from "react";
import { Link } from 'react-router-dom';
import './Maintenance & Support.css';
import Slide1 from "./Images/gaminiM&S.png";
import { FaTools, FaShieldAlt, FaSyncAlt, FaHeadset, FaBug, FaDatabase } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
const MaintenanceAndSupport = () => {
    return (
        <div className="maintenance-support-container">
            <Helmet>
  <title>IT Maintenance & Support Services | APTech Solution</title>
  <meta 
    name="description" 
    content="APTech Solution provides reliable IT maintenance and support services to ensure your websites, apps, and software run smoothly without downtime." 
  />
</Helmet>

            {/* Hero Section */}
            <section className="maintenance-hero">
                <h1>Maintenance & Support</h1>
                <p>Ensure smooth operations and long-term performance of your digital assets with our proactive maintenance and responsive support services.</p>
                <img src={Slide1} alt="Maintenance and Support" />
            </section>

            {/* Services Offered */}
            <section className="maintenance-services">
                <h2>Our Maintenance & Support Services</h2>
                <div className="maintenance-services-grid">
                    <div className="maintenance-card bottom-border-card">
                        <FaTools />
                        <h3>System Upgrades</h3>
                        <p>Keep your systems updated with the latest technologies for smooth and secure performance.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaShieldAlt />
                        <h3>Security Monitoring</h3>
                        <p>Continuous protection against threats through real-time security monitoring and quick response.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaSyncAlt />
                        <h3>Backup & Recovery</h3>
                        <p>Automated backups and fast recovery options to protect your data from loss or downtime.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaHeadset />
                        <h3>Technical Support</h3>
                        <p>24/7 expert support to troubleshoot, guide, and solve technical issues with minimal delay.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaBug />
                        <h3>Bug Fixing</h3>
                        <p>Quick detection and resolution of bugs to ensure optimal functionality and user experience.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaDatabase />
                        <h3>Database Optimization</h3>
                        <p>Enhance database speed and reliability through regular performance tuning and cleanup.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaSyncAlt />
                        <h3>Performance Tuning</h3>
                        <p>Boost software speed and responsiveness with code and server-side optimizations.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaShieldAlt />
                        <h3>Compliance & Updates</h3>
                        <p>Ensure your systems align with current regulations and best practices through ongoing updates.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaTools />
                        <h3>Code Refactoring</h3>
                        <p>Improve code quality and maintainability through regular refactoring and cleanup.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaHeadset />
                        <h3>User Support & Training</h3>
                        <p>Provide onboarding, product training, and end-user support to maximize adoption and productivity.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaBug />
                        <h3>Incident Management</h3>
                        <p>Fast issue tracking, root cause analysis, and resolution for critical system incidents.</p>
                    </div>
                    <div className="maintenance-card bottom-border-card">
                        <FaDatabase />
                        <h3>Infrastructure Monitoring</h3>
                        <p>Track server health, storage, and network performance to avoid downtime and failures.</p>
                    </div>
                </div>
            </section>


            {/* Why Choose Us */}
            <section className="maintenance-why-choose">
                <h2>Why Choose Us?</h2>
                <div className="maintenance-choose-grid">
                    <div className="choose-card">
                        <h3>Proactive Monitoring</h3>
                        <p>We prevent issues before they arise, minimizing downtime and disruption.</p>
                    </div>
                    <div className="choose-card">
                        <h3>Expert Team</h3>
                        <p>Our experienced engineers deliver quick and reliable solutions.</p>
                    </div>
                    <div className="choose-card">
                        <h3>Customized Plans</h3>
                        <p>Flexible maintenance options tailored to your business needs.</p>
                    </div>
                </div>
            </section>

            {/* Call To Action */}
            <section className="maintenance-cta">
                <h2>Keep Your Systems Running Smoothly</h2>
                <p>Contact us for a maintenance plan that suits your goals and infrastructure.</p>

                <Link to="/contact" state={{ scrollTo: "form" }}>
                    <button className="maintenance-cta-button">Get in Touch</button>
                </Link>
               
            </section>
        </div>
    );
};

export default MaintenanceAndSupport;
